
    import {defineComponent, computed, onMounted, onUnmounted, ref, PropType} from 'vue';
    import {AddressView} from '@/common/api/api-raw-types';
    import {LocationAutocomplete} from '@malt/location-autocomplete';

    export default defineComponent({
        name: 'LocationAutocomplete',
        props: {
            address: {type: Object as PropType<AddressView>},
            name: String,
            dataTestid: String,
            error: Boolean,
            required: Boolean,
        },
        emits: ['update:address'],
        setup(props, {emit}) {
            const location = ref(null);

            let locationAutocompleteInstance: any;

            onMounted(() => {
                locationAutocompleteInstance = new LocationAutocomplete({
                    input: location.value,
                    layer: 'LOCALITY',
                    focusPoint: window.GEOLOCATION_FOCUS_POINT,
                    defaultValue: props.address || null,
                    onSelect: (lastSelected: AddressView) => {
                        emit('update:address', lastSelected);
                    },
                });
            });

            onUnmounted(() => {
                locationAutocompleteInstance.destroy();
            });

            return {
                formattedAddress: computed(() => props.address?.formattedAddress),
                location,
            };
        },
    });
